module.exports = __webpack_public_path__ + "img/autospin_btn.d5e9f0b8.png";